import React, {useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useIsMountedRef from '../Components/useIsMountedRef';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {Link as UrlLink} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import SendIcon from '@material-ui/icons/Send';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  textFieldUppercase: {
    textTransform: 'uppercase'
  },

  dFlex: {display : 'flex'},
  fg1:   {flexGrow: 1     },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

var defaultFilter = {
  idService: '0',
  text: '',
  showExtendedInfo: false,
  showDeletedItems: false
};

export default function CovidLetters(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState(defaultFilter);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemOperation, setSelectedItemOperation] = useState(null);
  const [selectedItemWarning, setSelectedItemWarning] = useState(null);

  const fullScreen = useMediaQuery(useTheme().breakpoints.down('xs'));

  useEffect(() => {
    setIsLoaded(false);
    ajax('getCovidLetters')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const handleSelectedItemChange = (property = null) => e => {
    let value = null;
    switch (e.target.type) {
      case 'checkbox':
        value = e.target.checked;
        break;
      case 'file':
        value = Boolean(e.target.files.length) ? e.target.files[0] : null;
        console.log(value);
        break;

      default:
        value = e.target.value !== null ? e.target.value : '';
        break;
    }

    if (property)
      setSelectedItem({
        ...selectedItem,
        [property]: {...selectedItem[property], [e.target.name]: value}
      });
    else
      setSelectedItem({
        ...selectedItem,
        [e.target.name]: value
      });
  };

  useEffect(() => {
    if (selectedItemOperation === null || !selectedItem)
      return;

    var warning = null;
    switch (selectedItemOperation) {
      case 'editCovidLetter':
        warning = warning === null ? selectedItem.person === '' ? 'Nu ati completat numele persoanei' : null : warning;
        warning = warning === null ? selectedItem.rank === '' ? 'Nu ati completat functia sau CNP-ul' : null : warning;
        warning = warning === null ? selectedItem.analysesReportNo === '' ? 'Nu ati completat numarul raportului de analize' : null : warning;
        break;
      case 'sendCovidLetter':
        warning = warning === null ? selectedItem.email === '' ? 'Nu ati completat adresa de email' : null : warning;
        // warning = warning === null ? !Boolean(selectedItem.analysesReportFile) ? 'Nu ati selectat raportul de analize' : null : warning;
        break;

      default:
        break;
    }

    setSelectedItemWarning(warning);
  }, [data, selectedItem, selectedItemOperation]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterData = item => true
      && (filter.idService === '0' || item.idService === filter.idService)
      && (
           !!~item.person.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.idReceptionSL.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.analysesReportNo.toLowerCase().indexOf(filter.text.toLowerCase())
      )
      && ((!filter.showDeletedItems && item.deletedBy === null) || (filter.showDeletedItems && item.deletedBy !== null));

  const handleItemMenuOpen = item => e => {
    setSelectedItem({
      ...item,
      attachCovidLetter: true,
      attachAnalysisBulletin: true,
      analysisBulletinLanguageRo: true,
      analysisBulletinLanguageEn: true
    });
    setAnchorEl(e.currentTarget);
  };
  const handleItemMenuClick = operation => () => {
    setAnchorEl(null);
    setSelectedItemOperation(operation);

    switch (operation) {
      case 'downloadCovidLetter':
        window.open(`${props.url.download}?op=covidLetter&idCovidLetter=${selectedItem.idCovidLetter}&SID=${props.user.sessid}&variant=live`);
        handleItemMenuClose();
        break;

      default:
        break;
    }
  };
  const handleItemMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
    setSelectedItemOperation(null);
  };

  const handleEditCovidLetter = () => {
    setIsLoaded(false);
    ajax('saveCovidLetter', {
      ...selectedItem,
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleSendCovidLetter = () => {
    // console.log(selectedItem.analysesReportFile);
    setIsLoaded(false);
    ajax('sendCovidLetterToEmail', {
      idCovidLetter: selectedItem.idCovidLetter,
      email: selectedItem.email,
      attachCovidLetter: selectedItem.attachCovidLetter,
      attachAnalysisBulletin: selectedItem.attachAnalysisBulletin,
      analysisBulletinLanguageRo: selectedItem.analysisBulletinLanguageRo,
      analysisBulletinLanguageEn: selectedItem.analysisBulletinLanguageEn
    }/*, [{
      paramName: 'analysesReportFile',
      file: selectedItem.analysesReportFile
    }]*/)
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleDeleteCovidLetter = () => {
    setIsLoaded(false);
    ajax('markCovidLetterAsDeleted', {
      idCovidLetter: selectedItem.idCovidLetter,
      idReceptionServiceSL: selectedItem.idReceptionServiceSL
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleUndeleteCovidLetter = () => {
    setIsLoaded(false);
    ajax('markCovidLetterAsUndeleted', {
      idCovidLetter: selectedItem.idCovidLetter
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>
        <IconButton color='primary'
          onClick={() => {
            ajax('checkCovidLettersEmails');
          }}
        >
          <SearchIcon />
        </IconButton>
        Scrisori COVID-19
      </Typography>
      <Typography variant='subtitle2'>Generare scrisori COVID-19</Typography>
      <Typography>Sunt afisate doar scrisorile medicale care respecta toate cele patru conditii: 1. Receptia nu este stearsa din SmartLabs; 2. Nu s-a trimis email catre pacient; 3. Analizele sunt efectuate de catre un laborator extern SAU sunt efectuate de catre laboratorul propriu, cu rezultate complete, validate si negative; 4. Scrisoarea medicala nu a fost marcata ca stearsa.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.covidLetters.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.covidLetters.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' select
              label='Serviciu'
              placeholder='Serviciu'
              name='idService'
              value={filter.idService}
              onChange={handleFilterChange}
            >
              <MenuItem key='0' value='0'>Toate serviciile</MenuItem>
              {data.services.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.service}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showExtendedInfo'
                  checked={filter.showExtendedInfo}
                  value={filter.showExtendedInfo}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza informatii extinse'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showDeletedItems'
                  checked={filter.showDeletedItems}
                  value={filter.showDeletedItems}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza scrisorile sterse'
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.covidLetters.length > 0 && data.covidLetters.filter(filterData).length === 0 &&
        <Box>
          <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
          <Typography color='primary' align='center'>Daca v-ati pierdut, incercati resetarea filtrelor de <UrlLink href='#' color='initial' onClick={() => setFilter(defaultFilter)}>aici</UrlLink></Typography>
        </Box>
      }

      {isLoaded &&
        <List dense>
          {data.covidLetters.filter(filterData).map((item, i, a) =>
            <Fragment key={item.idReceptionServiceSL}>
              {(i === 0 || a[i].abbr !== a[i - 1].abbr) &&
                <ListSubheader color='primary' disableSticky>{item.abbr}</ListSubheader>
              }

              <ListItem button dense className={classes.listItemDense}
                selected={selectedItem && item.idReceptionServiceSL === selectedItem.idReceptionServiceSL}
                onClick={() => {
                  setSelectedItem(item);
                  setSelectedItemOperation('editCovidLetter');
                }}
              >
                <ListItemText className={classes.listItemTextDense} disableTypography
                  primary={
                    <Typography>
                      <Typography component='span' display='inline'>{item.dateOf} - </Typography>
                      <Typography component='span' display='inline' style={{fontWeight: 'bold'}}>{item.person}</Typography>
                    </Typography>
                  }
                  secondary={
                    <Box>
                      {item.isBad === '1'
                        ? <Warning display='block' color='secondary'>Se pare ca rezultatul este pozitiv, nu se elibereaza scrisoare!</Warning>
                        : item.isComplete === '0'
                          ? <Warning display='block' color='secondary'>Buletinul de analize nu este complet</Warning>
                          : item.resultsValidated === '0'
                            ? <Warning display='block' color='secondary'>Buletinul de analize nu este validat!</Warning>
                            : item.isUploaded === '0'
                              ? <Warning display='block' color='secondary'>Buletinul de analize nu este incarcat in WebLabs!</Warning>
                              : !Boolean(item.idCovidLetter)
                                ? <Warning display='block' color='secondary'>Verificati si confirmati informatiile acestei scrisori</Warning>
                                : null
                      }
                      <Typography component='span' variant='caption' display='block' color='textSecondary'>
                        {`ID SmartLabs: `}
                        <Typography display='inline' color='textPrimary' style={{fontWeight: 'bold'}}>{item.idReceptionSL}</Typography>
                      </Typography>
                      {filter.showExtendedInfo &&
                        <Box>
                          <Typography color='textSecondary'>
                            {`Data receptiei: `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.dateOf}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`Rank (CNP): `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.rank}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`Pasaport: `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.passport}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`Numar raport de analize: `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.analysesReportNo}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`Email: `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.email}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`Creat de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdBy}</Typography>
                            {` la data de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdAt}</Typography>
                          </Typography>
                        </Box>
                      }
                      {item.deletedBy &&
                        <Typography color='secondary'>{`Sters de ${item.deletedBy} la data de ${item.deletedAt}`}</Typography>
                      }
                      <Typography component='span' variant='caption' display='block' color='textSecondary'>
                        {`Memo SmartLabs: `}
                        <Typography display='inline' color='primary' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.memoSL ? item.memoSL : '-'}</Typography>
                      </Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge='end'
                    onClick={handleItemMenuOpen(item)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Fragment>
          )}
        </List>
      }

      <Menu keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleItemMenuClose}
      >
        <MenuItem divider={false} onClick={handleItemMenuClick('editCovidLetter')}>
          <ListItemIcon className={classes.listItemIcon}><EditIcon fontSize='small' /></ListItemIcon>
          <Typography variant='body1' style={{fontWeight: 'bold'}}>Modifica</Typography>
        </MenuItem>

        {selectedItem && Boolean(selectedItem.idCovidLetter) &&
          <MenuItem divider={false} onClick={handleItemMenuClick('sendCovidLetter')}>
            <ListItemIcon className={classes.listItemIcon}><SendIcon fontSize='small' /></ListItemIcon>
            <Typography variant='body1'>Trimite pe email</Typography>
          </MenuItem>
        }

        {selectedItem && Boolean(selectedItem.idCovidLetter) &&
          <MenuItem divider={false} onClick={handleItemMenuClick('downloadCovidLetter')}>
            <ListItemIcon className={classes.listItemIcon}><CloudDownloadIcon fontSize='small' /></ListItemIcon>
            <Typography variant='body1'>Descarca scrisoare</Typography>
          </MenuItem>
        }

        {selectedItem && !selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('deleteCovidLetter')}>
            <ListItemIcon className={classes.listItemIcon}><DeleteIcon fontSize='small' color='secondary' /></ListItemIcon>
            <Typography variant='body1' color='secondary'>Sterge</Typography>
          </MenuItem>
        }

        {selectedItem && selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('undeleteCovidLetter')}>
            <ListItemIcon className={classes.listItemIcon}><RestoreFromTrashIcon fontSize='small' color='primary' /></ListItemIcon>
            <Typography variant='body1' color='primary'>Anuleaza stergerea</Typography>
          </MenuItem>
        }
      </Menu>

      {selectedItem && selectedItemOperation === 'editCovidLetter' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted fullWidth maxWidth='md'
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'editCovidLetter'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>{`Detalii scrisoare ${selectedItem.person}`}</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography component='span'>
                    {`Memo SmartLabs: `}
                    <Typography component='span' display='inline' color='primary' style={{fontWeight: 'bold'}}>{selectedItem.memoSL}</Typography>
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                    label='Nume'
                    placeholder='Nume'
                    name='person'
                    value={selectedItem.person}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required inputProps={{readOnly: true}}
                    label='Data receptiei'
                    placeholder='Data receptiei'
                    name='dateOf'
                    value={selectedItem.dateOf}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                    label='Rank (CNP)'
                    placeholder='Rank (CNP)'
                    name='rank'
                    value={selectedItem.rank}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                    label='Pasaport'
                    placeholder='Pasaport'
                    name='passport'
                    value={selectedItem.passport}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required autoComplete='off' inputProps={{readOnly: !Boolean(parseInt(selectedItem.analysesReportIsRequired))}}
                    label='Nr. raport de analize'
                    placeholder='Nr. raport de analize'
                    name='analysesReportNo'
                    value={selectedItem.analysesReportNo}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required type='date' inputProps={{max: new Date().toISOString().split('T')[0]}}
                    label='Data scrisorii'
                    placeholder='Data scrisorii'
                    name='letterDate'
                    value={selectedItem.letterDate}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                    label='Email'
                    placeholder='Email'
                    name='email'
                    value={selectedItem.email}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={4}>
                  <TextField margin='none' required autoComplete='off'
                    label='Producator kit'
                    placeholder='Producator kit'
                    name='kitManufacturer'
                    value={selectedItem.kitManufacturer}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField margin='none' required autoComplete='off'
                    label='Denumire kit'
                    placeholder='Denumire kit'
                    name='kitName'
                    value={selectedItem.kitName}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid> */}
                <Grid item xs={12} sm={4}>
                  <Autocomplete margin='none' fullWidth freeSolo
                    options={data.kitManufacturers}
                    defaultValue={selectedItem.kitManufacturer}
                    renderInput={(params) => (
                      <TextField {...params} autoComplete='off'
                        label='Producator kit'
                        placeholder='Producator kit'
                      />
                    )}
                    value={selectedItem.kitManufacturer}
                    onChange={(e, value, reason) => {
                      setSelectedItem({
                        ...selectedItem,
                        kitManufacturer: value ? value : ''
                      });
                    }}
                    onBlur={e => {
                      setSelectedItem({
                        ...selectedItem,
                        kitManufacturer: e.target.value ? e.target.value : ''
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Autocomplete margin='none' fullWidth freeSolo
                    options={data.kitNames}
                    defaultValue={selectedItem.kitName}
                    renderInput={(params) => (
                      <TextField {...params} autoComplete='off'
                        label='Denumire kit'
                        placeholder='Denumire kit'
                      />
                    )}
                    value={selectedItem.kitName}
                    onChange={(e, value, reason) => {
                      setSelectedItem({
                        ...selectedItem,
                        kitName: value ? value : ''
                      });
                    }}
                    onBlur={e => {
                      setSelectedItem({
                        ...selectedItem,
                        kitName: e.target.value ? e.target.value : ''
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='primary' onClick={handleEditCovidLetter}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'sendCovidLetter' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'sendCovidLetter'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Trimiteti aceasta scrisoare pe email?</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography component='span'>
                    {`Memo SmartLabs: `}
                    <Typography component='span' display='inline' color='primary' style={{fontWeight: 'bold'}}>{selectedItem.memoSL}</Typography>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                    label='Email'
                    placeholder='Email'
                    name='email'
                    value={selectedItem.email}
                    onChange={handleSelectedItemChange()}
                  />
                </Grid>
                {/* <Grid item xs={12} style={{display: 'flex'}}>
                  <TextField margin='none' required inputProps={{readOnly: true}}
                    label='Raport de analize'
                    placeholder='Raport de analize'
                    name='analysesReportFile'
                    value={document.querySelector('#analysesReportFile') ? document.querySelector('#analysesReportFile').value.split(/(\\|\/)/g).pop() : ''}
                  />
                  <label htmlFor='analysesReportFile' style={{marginLeft: '-48px'}}>
                    <IconButton component='span' color='primary' edge='end' size='medium'>
                      <CloudUploadIcon />
                    </IconButton>
                  </label>
                  <input type='file' accept='application/pdf' hidden
                    id='analysesReportFile'
                    name='analysesReportFile'
                    onChange={handleSelectedItemChange()}
                  />
                </Grid> */}
                <Grid item xs={12} className={classes.dFlex}>
                  <FormControlLabel className={classes.fg1}
                    control={
                      <Checkbox color='primary' size='small'
                        name='attachCovidLetter'
                        checked={selectedItem.attachCovidLetter}
                        onChange={handleSelectedItemChange()}
                      />
                    }
                    label='Ataseaza scrisoarea medicala'
                  />
                </Grid>
                <Grid item xs={12} className={classes.dFlex}>
                  <FormControlLabel className={classes.fg1}
                    control={
                      <Checkbox color='primary' size='small'
                        disabled={!Boolean(selectedItem.isUploaded)}
                        name='attachAnalysisBulletin'
                        checked={selectedItem.attachAnalysisBulletin}
                        onChange={handleSelectedItemChange()}
                      />
                    }
                    label='Ataseaza buletinul de analize'
                  />
                  {selectedItem.attachAnalysisBulletin &&
                    <FormControlLabel
                      control={
                        <Checkbox color='primary' size='small'
                          disabled={!Boolean(selectedItem.isUploaded)}
                          name='analysisBulletinLanguageRo'
                          checked={selectedItem.analysisBulletinLanguageRo}
                          onChange={handleSelectedItemChange()}
                        />
                      }
                      label='Romana'
                    />
                  }
                  {selectedItem.attachAnalysisBulletin &&
                    <FormControlLabel
                      control={
                        <Checkbox color='primary' size='small'
                          disabled={!Boolean(selectedItem.isUploaded)}
                          name='analysisBulletinLanguageEn'
                          checked={selectedItem.analysisBulletinLanguageEn}
                          onChange={handleSelectedItemChange()}
                        />
                      }
                      label='Engleza'
                    />
                  }
                </Grid>
                {selectedItem.attachAnalysisBulletin && !Boolean(selectedItem.isUploaded) &&
                  <Grid item xs={12}>
                    <Warning display='block' style={{visibility: selectedItem.attachAnalysisBulletin ? 'visible' : 'hidden'}}>Buletinul de analize trebuie sa fie incarcat in weblabs pentru a se genera automat!</Warning>
                  </Grid>
                }
                <Grid item xs={12}>
                  <Typography component='span'>
                    {`Apasati pe TRIMITE doar daca sunteti sigur ca doriti sa trimiteti aceasta scrisoare pe adresa de email `}
                    <Typography component='span' display='inline' color='textPrimary' style={{fontWeight: 'bold'}}>{selectedItem.email}</Typography>
                  </Typography>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='secondary' onClick={handleSendCovidLetter}>
              Trimite
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'deleteCovidLetter' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'deleteCovidLetter'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Marcati aceasta scrisoare ca stearsa?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe STERGE doar daca sunteti sigur ca doriti sa stergeti aceasta scrisoare.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='secondary' onClick={handleDeleteCovidLetter}>
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'undeleteCovidLetter' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'undeleteCovidLetter'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Anulati marcarea acestei scrisori ca stearsa?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe DA doar daca sunteti sigur ca doriti sa anulati stergerea acestei scrisori.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleUndeleteCovidLetter}>
              DA
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Container>
  );
}